import { keyBy } from 'lodash';
import { TableColumnKey } from '../../../types/Table';
import { ApiResponse } from '../../../types/ApiResponse';
import useErrorMsgTranslate from '../../../hook/useErrorMsgTranslate';
import { Preview } from '../../../types/Preview';

interface UseTableRowsProps {
  validPreviews: Preview[];
  apiResponses: ApiResponse[];
}

type MapResultToTupleArray = () => any[][][];

const useTableRows = (props: UseTableRowsProps) => {
  const { validPreviews, apiResponses } = props;

  const { getErrorMsgTranslate } = useErrorMsgTranslate();

  const apiResponsesById = keyBy(apiResponses, 'originalRowNumber');

  const mapResultToTupleArray: MapResultToTupleArray = () => {
    return validPreviews.map((item) => {
      const object = apiResponsesById[item.originalRowNumber] ?? undefined;
      const mappedResult = [
        [TableColumnKey.pfhNo, item.pfh_no],
        [TableColumnKey.CreditCurrency, item.credit_currency],
        [TableColumnKey.CreditAmount, item.credit_amount],
        ['submissionError', getErrorMsgTranslate(object.error?.message)],
      ];
      return mappedResult;
    });
  };
  return { mapResultToTupleArray };
};
export default useTableRows;
